// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 10px;
}
@media (min-width: 991px) {
  .logo-container ion-img {
    width: 300px;
  }
}
@media (max-width: 375px) {
  .logo-container ion-img {
    width: 140px;
  }
}

.content {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow: hidden;
  position: relative;
}
@media (min-width: 991px) {
  .content {
    height: calc(100% - 50px);
    justify-content: space-around;
  }
}
@media (max-width: 375px) {
  .content {
    height: calc(100% - 20px);
  }
}

.card {
  overflow: hidden;
  padding: 0px 30px 15px;
  min-height: 360px;
  text-align: center;
  margin: 10px 10px 0px;
  background: url('home-page-border.svg') no-repeat center top/93%;
  color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  max-width: 360px;
  max-height: 400px;
}
@media (min-width: 991px) {
  .card {
    min-width: 350px;
    min-height: 350px;
    max-width: 400px;
    max-height: 400px;
  }
}
@media (max-width: 400px) {
  .card {
    margin-top: 0;
    min-width: 300px;
    max-width: 370px;
    min-height: 320px;
    max-height: 330px;
    background: url('home-page-border.svg') no-repeat center top/90%;
  }
}
.card .title {
  font-size: var(--home-page-title-font-size);
  font-family: var(--font-tusker);
  text-transform: uppercase;
  padding: 0 10px;
  color: white;
}
@media (max-width: 375px) {
  .card .title {
    font-size: 26px;
  }
}
.card .title2 {
  font-size: var(--home-page-title-font-size);
  font-family: var(--font-tusker);
  text-transform: uppercase;
  margin-bottom: 10px;
  padding: 0 10px;
  color: var(--ion-color-tertiary);
}
@media (max-width: 375px) {
  .card .title2 {
    font-size: 24px;
  }
}
.card .subtitle {
  font-size: var(--home-page-subtitle-font-size);
  text-transform: uppercase;
  margin-bottom: 10px;
  padding: 0 45px;
  color: white;
}
@media (min-width: 991px) {
  .card .subtitle {
    padding: 10px 100px;
  }
}
@media (max-width: 375px) {
  .card .subtitle {
    font-size: 14px;
  }
}
.card .info {
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 20px;
  color: white;
}
@media (max-width: 375px) {
  .card .info {
    font-size: 14px;
  }
}
.card .payment {
  width: 80%;
  display: flex;
  justify-content: center;
  position: relative;
}
.card .payment ion-img {
  width: 70%;
}
.card .payment::before {
  content: "";
  width: 80%;
  height: 1.5px;
  background-color: white;
  position: absolute;
  top: -10px;
}
.card .payment::after {
  content: "";
  width: 80%;
  height: 1.5px;
  background-color: white;
  position: absolute;
  bottom: -10px;
}

.orders-button-container {
  display: flex;
  justify-content: center;
  width: 300px;
  margin-top: 5px;
  margin-bottom: 0px;
}
.orders-button-container .img-block {
  position: relative;
}
.orders-button-container ion-icon {
  width: 120px;
  height: 120px;
  cursor: pointer;
  position: relative;
}
@media (max-width: 400px) {
  .orders-button-container ion-icon {
    width: 110px;
    height: 110px;
  }
}
.orders-button-container p {
  position: absolute;
  max-width: 100px;
  color: white;
  font-family: var(--font-tusker);
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  text-align: center;
}

app-burger-btn {
  color: var(--ion-color-primary) !important;
  padding: 5px 5px 0px;
}

.header-row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
}
.header-row h1, .header-row h3 {
  font-family: Tusker, sans-serif;
  color: var(--ion-color-primary);
  text-transform: uppercase;
  font-size: 28px;
  letter-spacing: 2px;
  padding-bottom: 15px;
}
@media (max-width: 400px) {
  .header-row h1, .header-row h3 {
    font-size: 24px;
  }
}

.links_wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}
.links_wrapper div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.links_wrapper div p {
  padding: 0px 20px;
  text-decoration: underline;
  font-size: 12px;
}

.lang-block {
  width: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
@media (min-width: 991px) {
  .lang-block {
    margin-top: 5px;
  }
}
.lang-block .flag-item {
  margin: 2px 10px;
  width: 35px;
  height: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.lang-block .flag-item .flag-wrapper {
  width: 35px;
  min-height: 35px;
  border-radius: 50%;
  border: 1px solid var(--ion-color-primary);
  overflow: hidden;
  opacity: 0.5;
  z-index: 999;
}
.lang-block .flag-item .flag-wrapper ion-img {
  object-fit: cover;
  padding: 3px;
  width: 100%;
  height: 100%;
}
.lang-block .flag-item .flag-wrapper.selected {
  opacity: 1;
}
.lang-block .flag-item h3 {
  padding-top: 5px;
  font-size: 12px;
  color: var(--ion-color-primary);
  text-transform: uppercase;
}

.bottom-img {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
}
.bottom-img ion-img {
  width: 100px;
}
.bottom-img .left {
  position: absolute;
  bottom: 40px;
  left: 0px;
  overflow: hidden;
}
.bottom-img .left ion-img {
  width: 150px;
  height: 150px;
}
@media (min-width: 991px) {
  .bottom-img .left ion-img {
    height: 300px;
    width: 400px;
    object-fit: contain;
  }
}
.bottom-img .right {
  position: absolute;
  bottom: 40px;
  right: 0px;
}
@media (max-width: 992px) {
  .bottom-img .right ion-img {
    height: 200px;
  }
}
@media (min-width: 991px) {
  .bottom-img .right ion-img {
    height: 400px;
    width: 200px;
    object-fit: contain;
  }
}

.links_wrapper {
  margin-bottom: 20px;
  z-index: 999;
}
.links_wrapper p {
  margin: 0px 20px;
  border-bottom: 1px solid var(--ion-color-subtitle);
  color: var(--ion-color-subtitle);
}

.amout_users {
  position: absolute;
  right: 10px;
  bottom: 2px;
}
.amout_users p {
  font-family: AppFont300, sans-serif;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.tabilo.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AADD;ACJE;EDOA;IACC,YAAA;EAAD;AACF;AAEC;EACC;IACC,YAAA;EAAD;AACF;;AAGA;EACC,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAAD;ACxBE;EDiBF;IASE,yBAAA;IACA,6BAAA;EAEA;AACF;AADC;EAZD;IAaE,yBAAA;EAIA;AACF;;AAFA;EACC,gBAAA;EACA,sBAAA;EAEA,iBAAA;EAEA,kBAAA;EACA,qBAAA;EACA,gEAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAGD;ACnDE;EDiCF;IAkBE,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;EAIA;AACF;AAHC;EAvBD;IAwBE,aAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;IACA,gEAAA;EAMA;AACF;AALC;EACC,2CAAA;EACA,+BAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AAOF;AANE;EAND;IAOE,eAAA;EASD;AACF;AAPC;EACC,2CAAA;EACA,+BAAA;EAEA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AAQF;AAPE;EARD;IASE,eAAA;EAUD;AACF;AAPC;EACC,8CAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AASF;ACrGE;EDuFD;IAQE,mBAAA;EAUD;AACF;AATE;EAVD;IAWE,eAAA;EAYD;AACF;AATC;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AAWF;AAVE;EALD;IAME,eAAA;EAaD;AACF;AAVC;EACC,UAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAYF;AAXE;EACC,UAAA;AAaH;AAXE;EACC,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAaH;AAVE;EACC,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AAYH;;AARA;EACC,aAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAWD;AAVC;EACC,kBAAA;AAYF;AAVC;EACC,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AAYF;AAVE;EAND;IAOE,YAAA;IACA,aAAA;EAaD;AACF;AAXC;EACC,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;AAaF;;AAVA;EACC,0CAAA;EACA,oBAAA;AAaD;;AAVA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAaD;AAZC;EACC,+BAAA;EACA,+BAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AAcF;AAbE;EAPD;IAQE,eAAA;EAgBD;AACF;;AAbA;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;AAgBD;AAfC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AAiBF;AAhBE;EACC,iBAAA;EACA,0BAAA;EACA,eAAA;AAkBH;;AAdA;EACC,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAiBD;ACxOE;EDkNF;IAOE,eAAA;EAmBA;AACF;AAlBC;EACC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAoBF;AAlBE;EACC,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EAKA,YAAA;EACA,YAAA;AAgBH;AAfG;EACC,iBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAiBJ;AAfG;EACC,UAAA;AAiBJ;AAbE;EACC,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,yBAAA;AAeH;;AAXA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAcD;AAZC;EAEE,YAAA;AAaH;AAXC;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AAaH;AAZG;EACD,YAAA;EACA,aAAA;AAcF;AClSE;ED0RA;IAEC,aAAA;IACA,YAAA;IACA,mBAAA;EAUD;AACF;AALC;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AAOH;ACxSE;EDoSA;IAEC,aAAA;EAMD;AACF;ACnTE;EDmTA;IAEC,aAAA;IACA,YAAA;IACA,mBAAA;EAED;AACF;;AAIA;EACC,mBAAA;EACA,YAAA;AADD;AAEC;EACC,gBAAA;EACA,kDAAA;EACA,gCAAA;AAAF;;AAIA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;AADD;AAGC;EACC,mCAAA;EACA,eAAA;AADF","sourcesContent":["@import '../../../theme/mixins';\n\n.logo-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\tmargin-bottom: 10px;\n\t@include desktop {\n\t\tion-img {\n\t\t\twidth: 300px;\n\t\t}\n\t}\n\t@media (max-width: 375px) {\n\t\tion-img {\n\t\t\twidth: 140px;\n\t\t}\n\t}\n}\n.content {\n\tdisplay: flex;\n\tjustify-content: space-around;\n\tflex-direction: column;\n\talign-items: center;\n\theight: 100%;\n\toverflow: hidden;\n\tposition: relative;\n\t@include desktop {\n\t\theight: calc(100% - 50px);\n\t\tjustify-content: space-around;\n\t}\n\t@media (max-width: 375px) {\n\t\theight: calc(100% - 20px);\n\t}\n}\n.card {\n\toverflow: hidden;\n\tpadding: 0px 30px 15px;\n\n\tmin-height: 360px;\n\n\ttext-align: center;\n\tmargin: 10px 10px 0px;\n\tbackground: url('../../../assets/tabilo/home-page-border.svg') no-repeat center top/93%;\n\tcolor: white;\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\talign-items: center;\n\tmax-width: 360px;\n\tmax-height: 400px;\n\n\t@include desktop {\n\t\tmin-width: 350px;\n\t\tmin-height: 350px;\n\t\tmax-width: 400px;\n\t\tmax-height: 400px;\n\t}\n\t@media (max-width: 400px) {\n\t\tmargin-top: 0;\n\t\tmin-width: 300px;\n\t\tmax-width: 370px;\n\t\tmin-height: 320px;\n\t\tmax-height: 330px;\n\t\tbackground: url('../../../assets/tabilo/home-page-border.svg') no-repeat center top/90%;\n\t}\n\t.title {\n\t\tfont-size: var(--home-page-title-font-size);\n\t\tfont-family: var(--font-tusker);\n\t\ttext-transform: uppercase;\n\t\tpadding: 0 10px;\n\t\tcolor: white;\n\t\t@media (max-width: 375px) {\n\t\t\tfont-size: 26px;\n\t\t}\n\t}\n\t.title2 {\n\t\tfont-size: var(--home-page-title-font-size);\n\t\tfont-family: var(--font-tusker);\n\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 10px;\n\t\tpadding: 0 10px;\n\t\tcolor: var(--ion-color-tertiary);\n\t\t@media (max-width: 375px) {\n\t\t\tfont-size: 24px;\n\t\t}\n\t}\n\n\t.subtitle {\n\t\tfont-size: var(--home-page-subtitle-font-size);\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 10px;\n\t\tpadding: 0 45px;\n\t\tcolor: white;\n\n\t\t@include desktop {\n\t\t\tpadding: 10px 100px;\n\t\t}\n\t\t@media (max-width: 375px) {\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n\n\t.info {\n\t\tfont-size: 16px;\n\t\tline-height: 19px;\n\t\tmargin-bottom: 20px;\n\t\tcolor: white;\n\t\t@media (max-width: 375px) {\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n\n\t.payment {\n\t\twidth: 80%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tposition: relative;\n\t\tion-img {\n\t\t\twidth: 70%;\n\t\t}\n\t\t&::before {\n\t\t\tcontent: '';\n\t\t\twidth: 80%;\n\t\t\theight: 1.5px;\n\t\t\tbackground-color: white;\n\t\t\tposition: absolute;\n\t\t\ttop: -10px;\n\t\t}\n\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\twidth: 80%;\n\t\t\theight: 1.5px;\n\t\t\tbackground-color: white;\n\t\t\tposition: absolute;\n\t\t\tbottom: -10px;\n\t\t}\n\t}\n}\n.orders-button-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 300px;\n\tmargin-top: 5px;\n\tmargin-bottom: 0px;\n\t.img-block {\n\t\tposition: relative;\n\t}\n\tion-icon {\n\t\twidth: 120px;\n\t\theight: 120px;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\n\t\t@media (max-width: 400px) {\n\t\t\twidth: 110px;\n\t\t\theight: 110px;\n\t\t}\n\t}\n\tp {\n\t\tposition: absolute;\n\t\tmax-width: 100px;\n\t\tcolor: white;\n\t\tfont-family: var(--font-tusker) ;\n\t\tposition: absolute;\n\t\ttop: 60%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%,-50%);\n\t\tfont-size: 12px;\n\t\ttext-align: center;\n\t}\n}\napp-burger-btn {\n\tcolor: var(--ion-color-primary) !important;\n\tpadding: 5px 5px 0px;\n}\n\n.header-row {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-bottom: 10px;\n\th1,h3 {\n\t\tfont-family: Tusker, sans-serif;\n\t\tcolor: var(--ion-color-primary);\n\t\ttext-transform: uppercase;\n\t\tfont-size: 28px;\n\t\tletter-spacing: 2px;\n\t\tpadding-bottom: 15px;\n\t\t@media (max-width: 400px) {\n\t\t\tfont-size: 24px;\n\t\t}\n\t}\n}\n.links_wrapper {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-bottom: 5px;\n\tdiv {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tp {\n\t\t\tpadding: 0px 20px;\n\t\t\ttext-decoration: underline;\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n}\n.lang-block {\n\twidth: 220px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-wrap: wrap;\n\t@include desktop {\n\t\tmargin-top: 5px;\n\t}\n\t.flag-item {\n\t\tmargin: 2px 10px;\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\t.flag-wrapper {\n\t\t\twidth: 35px;\n\t\t\tmin-height: 35px;\n\t\t\tborder-radius: 50%;\n\t\t\tborder: 1px solid var(--ion-color-primary);\n\t\t\toverflow: hidden;\n\t\t\t// @media (max-width: 400px) {\n\t\t\t// \twidth: 45px;\n\t\t\t// \tmin-height: 45px;\n\t\t\t// }\n\t\t\topacity: 0.5;\n\t\t\tz-index: 999;\n\t\t\tion-img {\n\t\t\t\tobject-fit: cover;\n\t\t\t\tpadding: 3px;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t\t&.selected {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\n\t\th3 {\n\t\t\tpadding-top: 5px;\n\t\t\tfont-size: 12px;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n}\n.bottom-img {\n\tposition:absolute;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\t\n\tion-img {\n   \n\t  width: 100px;\n\t}\n\t.left {\n\t  position: absolute;\n\t  bottom: 40px;\n\t  left: 0px;\n\t  overflow: hidden;\n\t  ion-img {\n\t\twidth: 150px;\n\t\theight: 150px;\n\n\t  }\n\t  @include desktop {\n\n\t\t\n\t\tion-img {\n\t\t\t// height: 50vh;\n\t\t\theight: 300px;\n\t\t\twidth: 400px;\n\t\t\tobject-fit: contain;\n\t\t\t// width: 200px;\n\t\t}\n\n\t  }\n\t}\n\t.right {\n\t  position: absolute;\n\t  bottom: 40px;\n\t  right: 0px;\n\n\t@include mobile {\n\t\tion-img {\n\n\t\t\theight: 200px;\n\t\t  }\n\t}\n\t  \n\t  @include desktop {\n\n\t\t\n\t\tion-img {\n\t\t\t// height: 50vh;\n\t\t\theight: 400px;\n\t\t\twidth: 200px;\n\t\t\tobject-fit: contain;\n\t\t\t// width: 200px;\n\t\t}\n\n\t  }\n\t}\n  }\n.links_wrapper {\n\tmargin-bottom: 20px;\n\tz-index: 999;\n\tp {\n\t\tmargin: 0px 20px;\n\t\tborder-bottom: 1px solid var(--ion-color-subtitle);\n\t\tcolor: var(--ion-color-subtitle);\n\t}\n\n}\n.amout_users {\n\tposition: absolute;\n\tright: 10px;\n\tbottom: 2px;\n\t\n\tp {\n\t\tfont-family: AppFont300, sans-serif;\n\t\tfont-size: 12px;\n\n\t}\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
